import { render, staticRenderFns } from "./switchTableCont.vue?vue&type=template&id=2bb86412"
import script from "./switchTableCont.vue?vue&type=script&lang=js"
export * from "./switchTableCont.vue?vue&type=script&lang=js"
import style0 from "./switchTableCont.vue?vue&type=style&index=0&id=2bb86412&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports